
import { FutureCommissionSettlementSchedule } from 'ah-api-gateways';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import SwipeableBox from '@/app/components/common/SwipeableBox.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';

@Component({
  components: {
    SwipeableBox,
  },
})
export default class FutureCommissionSchedule extends Mixins(WithRequestManager) {
  private data: FutureCommissionSettlementSchedule | null = null;

  private headerKeys: string[] = [];

  private index: number = 0;

  private step: number = 4;

  formatCurrencyValue = formatCurrencyValue;

  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'loadfutureCommissionData') {
      this.loadData();
    }
  }

  get isStackedView() {
    return this.$mediaQuery.is('smDown');
  }

  @Watch('isStackedView', { immediate: true })
  onViewSizeChange() {
    this.index = 0;
  }

  get max() {
    return this.headerKeys.length - 1;
  }

  created() {
    this.loadData();
  }

  loadData() {
    this.requestManager
      .sameOrCancelAndNew('loadfutureCommissionData', this.$services.trade.getFutureCommissionReport())
      .subscribe((response) => {
        this.headerKeys = [];
        this.data = response;
        this.headerKeys = Object.keys(this.data.totalCommissionsByCurrency);
      });
  }
}
